export * from '@/components/Team/TeamEdit';
export { default } from '@/components/Team/TeamEdit';
